<div *ngIf="_Loaded" style="width:100%">  
  <div *ngFor="let profile of ProfileData.Profiles; let MyIndex=index; let IsOdd=odd; let IsEven=even">        
    <section class="cd-section" *ngIf="MyIndex==ProfileIndex" [@HideShowAnimationState]="profile.state"
    (@HideShowAnimationState.start)="HidingStarted($event)"
    (@HideShowAnimationState.done)="HidingComplete($event)">      
      <div class="cd-half-block" [ngClass]="{'cd-half-shownright': IsEven}">
          <div class="cd-text-block">
            <div  [innerHTML]="profile.Role" class="ProfileRole" style="display:inline;"></div>
            <div style="display:inline-block" class="ProfileDate">{{profile.Date}}</div>
            <div  [innerHTML]="profile.Org" class="ProfileOrg"></div>
            <div  [innerHTML]="profile.Employee" class="ProfileConsulting" *ngIf="profile.Employee"></div>
            <div  [innerHTML]="profile.Profile" class="ProfileText"></div>
            <div  [innerHTML]="profile.Awards" class="ProfileText"></div>
            <div *ngIf="profile.Skills.length>0" class="ProfileSkills">
            Skills used on the project:<br/>
            <ul>
              <li *ngFor="let skill of profile.Skills; let MySkillIndex=index; let IsOddSkill=odd; let IsEvenSkill=even">
                <span class="ProfileSkills">{{skill.SkillType}}</span>
                <span>&nbsp;-&nbsp;</span>
                <span *ngFor="let tool of skill.Toolset; let ToolsetIndex=index; let IsOddToolset=odd; let IsEvenToolset=even" class="ProfileSkills">
                  <span *ngIf="ToolsetIndex > 0">,</span>
                  <span [innerHTML]="tool.SkillName" [title]="tool.SkillUse"></span>
                </span>

              </li>
            </ul>
            </div>
              
        </div>
      </div>
      <div class="cd-half-block" [style.background]="'url('+profile.ImageURL+')'" [style.background-size]="'cover'" [ngClass]="{'cd-half-shownright': IsOdd}">
        
      </div>
    </section>
  </div>
</div>
<nav>
    <ul class="cd-vertical-nav">
        <a class="cd-prev" (click)="Prev();">Next</a>
        <a class="cd-next" (click)="Next();">Prev</a>
    </ul>
</nav>